var _path, _path2, _path3, _path4, _g, _rect, _circle, _circle2, _circle3, _g2, _circle4, _g3, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstEventAttended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 222,
    viewBox: "0 0 123 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Medal Blue",
    filter: "url(#filter0_d_3333_31260)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 26",
    d: "M4.70898 7.83154C4.70898 4.05858 7.76757 1 11.5405 1H100.793C104.566 1 107.624 4.05859 107.624 7.83155V21.5198C107.624 25.2928 104.566 28.3514 100.793 28.3514H95.1157V13.9803H17.2175V28.3514H11.5405C7.76757 28.3514 4.70898 25.2928 4.70898 21.5198V7.83154Z",
    fill: "#FFEEB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23",
    d: "M4.70898 9.5542C4.70898 5.78124 7.76757 2.72266 11.5405 2.72266H100.793C104.566 2.72266 107.624 5.78124 107.624 9.55421V23.2425C107.624 27.0154 104.566 30.074 100.793 30.074H95.1157V15.703H17.2175V30.074H11.5405C7.76757 30.074 4.70898 27.0154 4.70898 23.2425V9.5542Z",
    fill: "#F4CC3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 22",
    d: "M17.2246 15.543H95.1064V70.6979L56.1655 98.0194L17.2246 70.6979V15.543Z",
    fill: "#2874BA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3333_31260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 79,
    height: 84
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 20",
    d: "M17.3906 15.543H95.2364V70.707L56.3135 98.0194L17.3906 70.707V15.543Z",
    fill: "#2874BA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3333_31260)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 21",
    x: 41.4062,
    y: -17.1953,
    width: 29.8133,
    height: 115.214,
    fill: "#2D4071"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    x: 49.6758,
    y: 83.5605,
    width: 12.5167,
    height: 21.3248,
    rx: 6.25836,
    fill: "#C09525"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 55.9345,
    cy: 154.849,
    r: 54.9345,
    fill: "url(#paint0_linear_3333_31260)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2",
    cx: 55.9341,
    cy: 154.85,
    r: 42.8814,
    fill: "#705100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3333_31260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 116,
    width: 87,
    height: 87
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 58.53,
    cy: 159.739,
    r: 42.9812,
    fill: "#C28B37"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3333_31260)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3",
    cx: 55.9343,
    cy: 154.85,
    r: 42.9812,
    fill: "#E3A504"
  })))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 56.515,
    cy: 155.158,
    r: 35.3099,
    fill: "#C18222"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5144 126.738L64.8395 143.676L81.4896 145.793L70.0565 158.834L73.1645 177.55L56.5144 169.081L39.8642 177.55L42.9999 158.834L31.5391 145.793L48.1893 143.676L56.5144 126.738Z",
    fill: "url(#paint1_linear_3333_31260)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9631 126.518L56.5144 125.605L56.0656 126.518L47.8592 143.213L31.476 145.297L30.5419 145.415L31.1635 146.123L42.4676 158.986L39.371 177.467L39.2072 178.445L40.0908 177.996L56.5144 169.642L72.9379 177.996L73.8199 178.444L73.6578 177.468L70.5885 158.986L81.8656 146.122L82.4854 145.415L81.5527 145.297L65.1695 143.213L56.9631 126.518Z",
    stroke: "#A36D1D",
    strokeOpacity: 0.2
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25",
    opacity: 0.5,
    d: "M95.4844 50.0898L17.1136 50.0898L17.1136 15.6412L95.4844 15.6412L95.4844 50.0898Z",
    fill: "url(#paint2_linear_3333_31260)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3333_31260",
    x: 0.216502,
    y: 0.216502,
    width: 122.405,
    height: 221.319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.48449,
    dy: 5.48449
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.13399
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3333_31260"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3333_31260",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3333_31260",
    x1: 55.9345,
    y1: 99.9141,
    x2: 55.9345,
    y2: 209.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD12D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3333_31260",
    x1: 56.5144,
    y1: 126.738,
    x2: 56.5144,
    y2: 177.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFFFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE86D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3333_31260",
    x1: 56.299,
    y1: 50.0898,
    x2: 56.299,
    y2: 15.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D62A2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14275A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstEventAttended);
export default __webpack_public_path__ + "static/media/First_Event_Attended.493e562a8e837d7bb6dba3964eab021f.svg";
export { ForwardRef as ReactComponent };